import { createFromIconfontCN } from '@ant-design/icons';
import { icon } from '../assets/icon/iconfont';
const IconFont = createFromIconfontCN({
	scriptUrl: { icon }
});

export default IconFont;
